const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  STATE: 'state',
  CODE_VERIFIER: 'code_verifier',
} as const;

class Storage {
  static getItem<T>(key: string) {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(`Error setting item in local storage: ${error}`);
    }
    return item as T;
  }

  static setItem<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting item in local storage: ${error}`);
    }
  }

  static removeItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from local storage: ${error}`);
    }
  }

  static clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error(`Error clearing local storage: ${error}`);
    }
  }

  static clearAllExceptIntl(): void {
    try {
      Storage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      Storage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
      Storage.removeItem(STORAGE_KEYS.STATE);
      Storage.removeItem(STORAGE_KEYS.CODE_VERIFIER);
    } catch (error) {
      console.error(`Error clearing local storage: ${error}`);
    }
  }
}

export { STORAGE_KEYS };
export default Storage;
